import { render, staticRenderFns } from "./NotFoundSvg.vue?vue&type=template&id=680f0e16&"
import script from "./NotFoundSvg.vue?vue&type=script&lang=ts&"
export * from "./NotFoundSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports